export default "__VITE_ASSET__M$cVhXu2__"